import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from '../../components/TopNav';
import Footer from '../../components/Footer';
import { useAuthUserContext } from '../../providers/AuthUser';
import { UserType } from '../../types';
import { useTitle } from '../../hooks/useTitle';

const NotFoundPage: React.FC = () => {
  const { user } = useAuthUserContext();

  useTitle('Ton Bébé | 404 - ページが見つかりません');

  return (
    <>
      <header>
        <TopNav />
      </header>
      <main className="sub">
        <section className="not-found">
          <div className="not-found-content">
            <h1 className="error-code txt_orange">404</h1>
            <h2 className="error-title">ページが見つかりません</h2>
            <p className="error-message">
              お探しのページは削除されたか、URLが変更された可能性があります。
            </p>
            <div className="error-actions">
              <Link to="/" className="bluebtn">
                トップページへ
              </Link>
              { user && (
                <Link
                  to="/mypage"
                  className={ user.userType === UserType.Donor ? 'w_bluebtn' : 'w_pinkbtn' }
                >
                  マイページへ
                </Link>
              ) }
              { user && user.userType === UserType.Donee && (
                <Link to="/search-result" className="orangebtn">
                  ドナー検索へ
                </Link>
              ) }
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <style>{ `
        .not-found {
          text-align: center;
          padding: 80px 20px;
          min-height: calc(100vh - 400px);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .not-found-content {
          max-width: 600px;
          margin: 0 auto;
        }

        .error-code {
          font-size: 120px;
          font-weight: bold;
          margin: 0 0 20px;
          line-height: 1;
        }

        .error-title {
          font-size: 28px;
          font-weight: bold;
          color: #333;
          margin: 0 0 20px;
        }

        .error-message {
          font-size: 16px;
          color: #666;
          margin: 0 0 40px;
          line-height: 1.6;
        }

        .error-actions {
          display: flex;
          gap: 15px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .error-actions a {
          text-decoration: none;
          padding: 12px 30px;
        }

        @media (max-width: 768px) {
          .not-found {
            padding: 60px 20px;
          }

          .error-code {
            font-size: 80px;
          }

          .error-title {
            font-size: 24px;
          }

          .error-message {
            font-size: 14px;
          }

          .error-actions {
            flex-direction: column;
            align-items: center;
          }

          .error-actions a {
            width: 200px;
          }
        }
      ` }</style>
    </>
  );
};

export default NotFoundPage;
